import { render } from "./index.vue?vue&type=template&id=6d75cfd0&scoped=true"
import script from "./page-heading.js?vue&type=script&lang=js"
export * from "./page-heading.js?vue&type=script&lang=js"

import "./page-heading.scss?vue&type=style&index=0&id=6d75cfd0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\devin\\Desktop\\Web\\Portfolios\\Portolio\\vue-personal-portfolio\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d75cfd0"]])

export default __exports__